import {useAppDispatch, useAppSelector} from '../../../stores/configureStore'
import {setAttribute} from '../../../stores/editor/editor.reducer'
import {handleUpdatedAttributes} from '../../../utils/helpers/attributeHelper'
import InputSlider from '../../toolbox/sliders/InputSlider'
import ControlsBase from './ControlsBase'

interface ControlsProps {
  open: boolean
  onBackClick?: () => void
}

export default function CurveControls({open, onBackClick}: ControlsProps) {
  const dispatch = useAppDispatch()
  const selectedImage = useAppSelector(store =>
    store.editor.images.find(
      image => image.id === store.editor.selectedImageId,
    ),
  )

  return (
    <ControlsBase open={open} onBackClick={onBackClick}>
      <InputSlider
        fullWidth
        xMin={-20}
        xMax={20}
        xStep={1}
        x={selectedImage?.type === 'caption' ? selectedImage.curvatureLevel : 0}
        marker={((0 - -20) / (20 - -20)) * 100}
        onDragEnd={(value: number) => {
          if (selectedImage) {
            handleUpdatedAttributes(dispatch, selectedImage, {
              curvatureLevel: value,
            })
          }
        }}
        onChange={(value: number) => {
          if (selectedImage) {
            dispatch(
              setAttribute({
                id: selectedImage.id,
                data: {curvatureLevel: value},
              }),
            )
          }
        }}
      />
    </ControlsBase>
  )
}
